import { Switch } from 'antd';
import React from 'react';

const tableConfig = (props) => (
	{
		columns: [
			{
				title: 'Version Name', field: 'versionName', filterAndSearch: false,
			},
			{
				title: 'Version Code', field: 'versionCode', filterAndSearch: false,
			},
			{
				title: 'Version OS', field: 'os', filterAndSearch: false,
			},
			{
				title: 'Force Update Required', field: 'required', filterAndSearch: false,
				render: rowData => <div><Switch checked={rowData.required || false} /></div >
			},
			{
				title: 'Description', field: 'description', filterAndSearch: false, width: "250px",
			},
		],
	}
)

export default tableConfig;
